export default __webpack_public_path__ + "static/media/premium-logo-text.1d64791ceab25009f317ab4fb20ddaa7.svg";